var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fold"}},[(_vm.unFold)?_c('div',{class:[`${_vm.$appPrefix}-fold-if`, _vm.themeClass]},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }